import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { ResetCache, type ResetCacheMutation, type ResetCacheMutationVariables } from './resetCache.graphql';

export type ResetCacheResult = {
	success: boolean;
};

export async function resetCacheApi({ gql: { fetch } }: UtilityContext): Promise<ResetCacheResult> {
	try {
		await fetch<ResetCacheMutation, ResetCacheMutationVariables>({
			query: ResetCache,
			batched: false, // to ensure this rate limited mutation is not batched
			rejectOnError: true,
		});

		return { success: true };
	} catch (e) {
		return { success: false };
	}
}
